import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=37e13651&"
import script from "./AreaEdit.vue?vue&type=script&lang=js&"
export * from "./AreaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports